// All action types

const room = {
  REQUEST_ROOMS: 'REQUEST_ROOMS',
  SERVER_ERROR_OCURED: 'SERVER_ERROR_OCURED',
}

export default room



// WEBPACK FOOTER //
// src/routes/Room/actions/actionTypes.js